import { toRefs, watch, reactive, computed } from "vue";
import { v4 as uuidv4 } from 'uuid';
import companyService from "./companyService";
import config from "../../config"
let pathParts = document.location.pathname.split('/');
import getCustomDomain from '../helpers/getCustomDomain'


let storageKeyExtension = ''

//on a custom domain we dont need no extension, because localstorage is bound to domain
if (!getCustomDomain()) {    
    //old system
    if (pathParts.length > 2 && pathParts[1] == 'company') {
        storageKeyExtension = pathParts[2];
    }
    if (pathParts.length > 1 && pathParts[1] != 'company') {
        storageKeyExtension = pathParts[1];
    }
    if(!storageKeyExtension){
        storageKeyExtension = uuidv4();
    }
    storageKeyExtension = '-' + storageKeyExtension
}

let localStorageKey = 'oido-store-v9' + storageKeyExtension;

function writeToLocalStorage(data) {
    // console.log('writeToLocalStorage', data, JSON.stringify(data))
    localStorage.setItem(localStorageKey, JSON.stringify(data))
}
function readFromLocalStorage() {
    let data = JSON.parse(localStorage.getItem(localStorageKey));
    // console.log('readFromLocalStorage', data)
    return data;

}

var stateTimer = null;

const companyServiceInstance = companyService();

const unsubscribeHandles = [];

async function teardown() {
    for (let unsubscribeHandle of unsubscribeHandles) {
        await unsubscribeHandle();
    }
    //empty it
    unsubscribeHandles.length = 0;
    clear();
}


const state = reactive({
    // const state = reactive({
    initialized: false,
    initializing: false,
    error: null,
    items: {},
    address: {},
    itemsByCourse: {},
    tipPercentage: 10,
    deliveryType: 'takeaway',
    pickupTimeMode: 'assoonaspossible',
    paymentType: 'online',
    pickupTime: null,
    phone: null,
    note: null,
    voucher: null,
    voucherDiscount: null,
    discounts: [],
    activeTags: []
});


function clear() {
    state.items = {};
    state.tipPercentage = 10;
    state.itemsByCourse = {};
    state.deliveryType = 'takeaway';
    state.pickupTimeMode = 'assoonaspossible';
    state.pickupTime = null;
    state.paymentType = 'online';
    state.note = null;
    state.voucher = null;
    state.discounts = [];
    state.phone = null;
    state.address = {}
    initItemsByCourse();
}

function emptyTheCart() {
    localStorage.removeItem(localStorageKey)
    if (stateTimer) {
        clearTimeout(stateTimer)
    }
    stateTimer = 'dont'
    clear();

    stateTimer = setTimeout(() => {
        localStorage.removeItem(localStorageKey)
        stateTimer = 'dont'
        clear();
        stateTimer = null;
    }, 800)

}


function changeNote(product, note) {
    if (!product || !product.id) {
        console.log('changeNote no product given', product)
        return
    }
    if (!state.items[product.id]) {
        console.log('changeNote no product found', product)
        return
    }
    state.items[product.id].note = note ? note : null;
}

function getQuantityForProduct(product) {
    if (!product || !product.id) {
        console.log('getQuantityForProduct no product given', product)
        return 0
    }
    if (!state.items[product.id]) {
        return 0
    }
    return state.items[product.id].quantity ? state.items[product.id].quantity : 0;
}

function addProductToBasket(product, chosenItems, addons) {

    if (!product || !product.id) {
        console.log('addProductToBasket no product given', product)
        return 0
    }



    let itemId = product.id + '-||-' + uuidv4()
    if (!state.items[itemId]) {
        state.items[itemId] = { id: itemId }
    }

    state.items[itemId].quantity = state.items[itemId].quantity ? state.items[itemId].quantity + 1 : 1;
    state.items[itemId].chosen = chosenItems;
    state.items[itemId].addons = addons && Object.keys(addons).length > 0 ? addons : null;
    state.items[itemId].productId = product.id;

    if (product.type == 'combined') {
        for (let slotId in chosenItems) {
            let chosenProductId = chosenItems[slotId];
            let chosenProduct = companyServiceInstance.getProductById(chosenProductId)

            if (!state.itemsByCourse[chosenProduct.defaultCourseId]) {
                state.itemsByCourse[chosenProduct.defaultCourseId] = [];
            }
            state.itemsByCourse[chosenProduct.defaultCourseId].push({ productId: chosenProduct.id, parentId: product.id, cartItemId: itemId, note: null, slotId: slotId, key: itemId + slotId + 1 });
        }
    } else {
        state.itemsByCourse[product.defaultCourseId].push({ productId: product.id, cartItemId: itemId, note: null, key: itemId + 1 });
    }
}

function deleteItemFromCart(item) {

    if (!item || !item.id) {
        console.log('deleteItemFromCart no item given', item)
        return
    }

    if (!state.items[item.id]) {
        return
    }

    for (let courseId in state.itemsByCourse) {
        state.itemsByCourse[courseId] = state.itemsByCourse[courseId].filter((itemInCourse) => !itemInCourse.cartItemId || itemInCourse.cartItemId != item.id)
    }

    delete state.items[item.id];
}


function countCartItemDown(item) {

    if (!item || !item.id) {
        console.log('countCartItemDown no item given', item)
        return
    }
    if (!state.items[item.id]) {
        return
    }

    let itemsToDelete = null


    if (item.product.type == 'combined') {
        itemsToDelete = Object.values(item.chosen)
    } else {
        itemsToDelete = [item.productId]
    }


    state.items[item.id].quantity = state.items[item.id].quantity && state.items[item.id].quantity > 1 ? state.items[item.id].quantity - 1 : 0;


    if (state.items[item.id].quantity <= 0) {
        delete state.items[item.id];
    }

    let newItemsByCourse = {}

    for (let courseId in state.itemsByCourse) {
        newItemsByCourse[courseId] = [];
        let courses = state.itemsByCourse[courseId];
        for (let itemInCourse of courses) {

            if (itemsToDelete.includes(itemInCourse.productId) && itemInCourse.cartItemId == item.id) {
                let index = itemsToDelete.indexOf(itemInCourse.productId);
                itemsToDelete.splice(index, 1);
            } else {
                newItemsByCourse[courseId].push(itemInCourse);
            }
        }
    }

    state.itemsByCourse = newItemsByCourse;
}

function removeCartItem(itemId) {
    if (!itemId) {
        console.log('removeCartItem no itemId given', itemId)
        return
    }
    if (!state.items[itemId]) {
        return
    }
    delete state.items[itemId];

    let newItemsByCourse = {}

    for (let courseId in state.itemsByCourse) {

        newItemsByCourse[courseId] = [];
        let courses = state.itemsByCourse[courseId];
        for (let itemInCourse of courses) {
            if (itemInCourse.cartItemId != itemId) {
                newItemsByCourse[courseId].push(itemInCourse);
            }
        }
    }
    state.itemsByCourse = newItemsByCourse;
}

function countCartItemUp(item) {
    if (!item || !item.id) {
        console.log('countCartItemUp no item given', item)
        return 0
    }

    let itemId = item.id;
    if (!state.items[itemId]) {
        state.items[itemId] = {}
    }
    state.items[itemId].quantity = state.items[itemId].quantity ? state.items[itemId].quantity + 1 : 1;
    state.items[itemId].productId = item.productId;

    if (!state.itemsByCourse[item.product.defaultCourseId]) {
        state.itemsByCourse[item.product.defaultCourseId] = [];
    }

    if (item.product.type == 'combined') {
        for (let slotId in item.chosen) {
            let chosenProductId = item.chosen[slotId];
            let product = companyServiceInstance.getProductById(chosenProductId)
            if (!product) {
                continue;
            }
            state.itemsByCourse[product.defaultCourseId].push({ productId: product.id, parentId: item.productId, cartItemId: item.id, note: null, slotId: slotId, key: item.id + slotId + state.items[itemId].quantity });
        }
    } else {
        state.itemsByCourse[item.product.defaultCourseId].push({ productId: item.productId, cartItemId: item.id, note: null, key: item.id + state.items[itemId].quantity });
    }
}

function totalNumberOfItems() {
    let total = 0;
    for (let productId in state.items) {
        let item = state.items[productId];
        if (item.quantity) {
            total = total + item.quantity;
        }
    }
    return total;
}

function getCartBreakdown() {
    let subtotal = 0;
    let total = 0;
    let netAmount = 0;
    let grossAmount = 0;
    let rebates = {}
    let vatByRate = {};

    let company = companyServiceInstance.company.value;

    for (let productId in state.items) {
        let item = state.items[productId];
        let product = companyServiceInstance.getProductById(item.productId)

        if (!product) {
            continue;
        }
        let productPriceWithAddonsAndCorrections = Number.parseFloat(product.price)


        if (item.addons && Object.values(item.addons).length > 0) {
            for (let addonId in item.addons) {

                if (!item.addons[addonId]) {
                    continue
                }

                let addon = null;
                for (let addonItem of product.addons) {
                    if (addonItem.id == addonId) {
                        addon = addonItem;
                        break;
                    }
                }

                if (!addon) {
                    continue
                }
                if (addon.price && Number.parseFloat(addon.price)) {
                    productPriceWithAddonsAndCorrections += Number.parseFloat(addon.price);
                }
            }
        }


        if (product.type == 'combined' && product.slots && product.slots.length > 0) {
            for (let slot of product.slots) {
                // console.log("item.chosen", item, item.chosen)
                let productId = item.chosen[slot.id] ? item.chosen[slot.id] : null;
                if (productId && slot.availableProducts[productId] && slot.availableProducts[productId].correction) {
                    if (slot.availableProducts[productId].correction) {
                        productPriceWithAddonsAndCorrections += Number.parseFloat(slot.availableProducts[productId].correction)
                    }
                }
            }
        }

        let vatRate = Number.parseInt(companyServiceInstance.getTaxForProduct(item.productId));
        netAmount += (item.quantity * productPriceWithAddonsAndCorrections) / ((100 + vatRate) / 100)

        if (vatRate > 0) {
            if (!vatByRate[vatRate]) {
                vatByRate[vatRate] = 0.0;
            }
            vatByRate[vatRate] += ((item.quantity * productPriceWithAddonsAndCorrections) / (100 + vatRate)) * vatRate;
        }

        if (item && item.quantity && product && productPriceWithAddonsAndCorrections) {
            subtotal = subtotal + (item.quantity * productPriceWithAddonsAndCorrections);
        }

        // console.log('netAmount', netAmount)
        // console.log('subtotal', subtotal)
    }



    if (applicableDiscounts.value && applicableDiscounts.value.length > 0) {

        for (let discount of applicableDiscounts.value) {


            let rebate = Number.parseFloat(subtotal) / 100 * Number.parseFloat(discount.percentage);
            subtotal = subtotal - rebate

            let netChange = Number.parseFloat(netAmount) / 100 * Number.parseFloat(discount.percentage);
            netAmount = netAmount - netChange

            for (let vatRate in vatByRate) {
                vatByRate[vatRate] = vatByRate[vatRate] / 100 * (100 - Number.parseFloat(discount.percentage))
            }
            rebates[discount.id] = rebate
        }
    }


    let tip = Number.parseFloat(subtotal) / 100 * state.tipPercentage;
    if (company && company.tipIsEnabled) {
        if (company.tipIsTaxed && company.vatForTips) {
            let vatForTip = 0;
            let vatRateForTip = Number.parseFloat(company.vatForTips);
            vatForTip = (tip / (100 + vatRateForTip)) * vatRateForTip;
            if (!vatByRate[vatRateForTip]) {
                vatByRate[vatRateForTip] = 0;
            }
            vatByRate[vatRateForTip] += vatForTip;
            netAmount += (tip - vatForTip);
            grossAmount = subtotal + tip;
            total = grossAmount;
        } else {//tips enabled but not taxed 
            grossAmount = subtotal;
            total = grossAmount + tip;
        }
    } else {//tips not enabled
        grossAmount = subtotal;
        total = grossAmount;
    }

    return {
        grossAmount,
        netAmount,
        vatByRate,
        tip: tip,
        subtotal,
        total,
        rebates
    }
}

function productsInCart() {
    let products = [];
    for (let itemId in state.items) {
        let item = state.items[itemId]
        let product = companyServiceInstance.getProductById(item.productId);
        if (state.items[itemId] && product) {
            products.push(product);
        }
    }
    return products;
}

function itemsInCart() {
    let itemsWithProduct = [];
    for (let itemId in state.items) {
        let item = state.items[itemId]
        item.id = itemId;
        let product = companyServiceInstance.getProductById(item.productId);
        if (product) {
            item.product = product
        }
        itemsWithProduct.push(item)
    }
    return itemsWithProduct;
}


function initItemsByCourse() {

    // console.log('initItemsByCourse!!!!!!!!!', companyServiceInstance.company.value);

    if (companyServiceInstance.company && companyServiceInstance.company.value && companyServiceInstance.company.value.id) {

        let company = companyServiceInstance.company.value;
        state.tipPercentage = company.defaultTipPercentage;

        let activePointofsale = companyServiceInstance.activePointofsale && companyServiceInstance.activePointofsale.value ? companyServiceInstance.activePointofsale.value : null



        let hasOnlinePaymentsEnabled = activePointofsale && activePointofsale.enableOnlinePayment;
        //default to online payments, only choose deleviery if takeaway is not enabled (there should always be at least one of them enabled)
        state.paymentType = !hasOnlinePaymentsEnabled ? "offline" : "online";


        //check if allproducts used by cartitems are still valid (exist and are visible)
        //if not simply delete them
        let copiedItemsByCourse = JSON.parse(JSON.stringify(state.itemsByCourse));
        for (let courseId in copiedItemsByCourse) {
            let courses = copiedItemsByCourse[courseId];
            for (let itemInCourse of courses) {
                let cartItem = getCartItemById(itemInCourse.cartItemId)
                if (!cartItem) {
                    continue
                }

                let product = companyServiceInstance.getProductById(itemInCourse.productId);
                if (!product) {
                    removeCartItem(itemInCourse.cartItemId)
                    continue;
                }


                if (cartItem.product && cartItem.product.type == 'combined') {
                    //check if the parentproduct is still available
                    let parentProduct = companyServiceInstance.getProductById(itemInCourse.parentId);

                    if (!parentProduct) {
                        removeCartItem(itemInCourse.cartItemId)
                        continue;
                    }



                    if (itemInCourse.slotId && cartItem.product.slots) {
                        // console.log('cartItem.product', cartItem.product)
                        for (let slot of parentProduct.slots) {
                            // console.log('slot', slot, itemInCourse)
                            if (slot.id == itemInCourse.slotId && slot.availableProducts[itemInCourse.productId]) {
                                // console.log('slot.availableProducts[itemInCourse.productId]', slot.availableProducts[itemInCourse.productId], parentProduct)
                                if (slot.availableProducts[itemInCourse.productId].hidden) {
                                    // console.log('found hidden product',slot.availableProducts[itemInCourse.productId])
                                    removeCartItem(itemInCourse.cartItemId)
                                    continue;
                                }
                            }
                        }
                    }
                }
            }
        }




        let availableDeliveryOptions = [];
        if (activePointofsale.enableTableService) {
            availableDeliveryOptions.push('table')
        }

        if (activePointofsale.enablePickup) {
            availableDeliveryOptions.push('takeaway')
        }
        if (activePointofsale.enableDelivery) {
            availableDeliveryOptions.push('delivery')
        }

        if (availableDeliveryOptions.length > 0) {
            state.deliveryType = availableDeliveryOptions[0]
        }
    }


    if (Object.keys(state.itemsByCourse).length > 0) {
        // console.log('items already initialized');
        return;
    }


    state.itemsByCourse = {}

    if (companyServiceInstance.company && companyServiceInstance.company.value) {

        let company = companyServiceInstance.company.value;
        state.tipPercentage = company.defaultTipPercentage;

        if (!company.courses) {
            return
        }
        for (let course of company.courses) {
            state.itemsByCourse[course.id] = []
        }
    }


    for (let itemId in state.items) {
        let item = state.items[itemId]
        let product = companyServiceInstance.getProductById(itemId);
        if (!state.itemsByCourse[product.defaultCourseId]) {
            console.log('wrong courseId', product.defaultCourseId)
        }
        for (let i = 0; i < item.quantity; i++) {
            let line = { productId: product.id, cartItemId: itemId, note: null }
            state.itemsByCourse[product.defaultCourseId].push(line)
        }
    }




}

function getCartItemById(cartItemId) {
    if (!cartItemId || !state.items[cartItemId]) {
        return null
    }
    return state.items[cartItemId];
}

const longestManufacturingTimeInMinutes = computed(() => {
    let maxMinutes = 0
    for (let itemId in state.items) {
        let item = state.items[itemId]
        let product = companyServiceInstance.getProductById(item.productId);
        if (!product || !product.manufacturingTime) {
            continue
        }
        let unit = product.manufacturingTimeUnit ? product.manufacturingTimeUnit : 'days'
        let minutes = product.manufacturingTime * ((unit == 'days') ? 24 * 60 : (unit == 'hours') ? 60 : 1)


        if (minutes > maxMinutes) {
            maxMinutes = minutes
        }
    }
    return maxMinutes
})


const applicableDiscounts = computed(() => {
    let applicableDiscounts = []

    if (state.voucherDiscount) {
        applicableDiscounts.push(state.voucherDiscount)
    }

    if (state.discounts && state.discounts.length > 0) {
        for (let discount of companyServiceInstance.company.value.discounts) {
            let isAlreadyIncluded = applicableDiscounts.filter((elem) => elem.id == discount.id).length > 0

            if (state.discounts.includes(discount.id) && !isAlreadyIncluded) {
                applicableDiscounts.push(discount)
            }
        }
    }
    return applicableDiscounts;
})

export default function (reInit) {
    // console.log('cartService', state.initialized ,state.initializing)

    if (reInit) {
        state.initialized = false;
        state.initializing = false;
    }

    if (!state.address) {
        state.address = {}
    }


    if (!state.initialized && !state.initializing) {
        state.initializing = true;

        let savedData = readFromLocalStorage();
        for (let key in savedData) {
            state[key] = savedData[key]
        }

        initItemsByCourse()

        state.initialized = true
        state.initializing = false

    }


    watch(companyServiceInstance.company, (company) => {

        if (!company) {
            console.log('no company!!!!')
            clear();
            window.location.replace(config.url);
            return;
        }

        let existingTagIds = company.tags && company.tags.map((tag) => tag.id);
        let cleanedActiveTags = []
        for (let activeTagId of state.activeTags) {
            if (existingTagIds && existingTagIds.includes(activeTagId)) {
                cleanedActiveTags.push(activeTagId)
            }
        }
        state.activeTags = cleanedActiveTags;


        //add any new courses to itemsByCourse
        if (company.courses) {
            for (let course of company.courses) {
                if (!state.itemsByCourse[course.id]) {
                    state.itemsByCourse[course.id] = []
                }
            }
        }

        //remove any deleted courses        
        let existingCourseIds = company.courses && company.courses.map((course) => course.id);
        if (existingCourseIds) {
            for (let courseId in state.itemsByCourse) {
                if (!existingCourseIds.includes(courseId)) {

                    //deleted couse has items in it -> move those to their respective default course
                    if (state.itemsByCourse[courseId].length > 0) {
                        for (let item of state.itemsByCourse[courseId]) {
                            let product = companyServiceInstance.getProductById(item.productId);

                            if (product && product.defaultCourseId && product.defaultCourseId != courseId && state.itemsByCourse[product.defaultCourseId]) {
                                state.itemsByCourse[product.defaultCourseId].push(item)
                            }
                        }
                    }
                    // deleted course has no items -> simple remove it
                    delete state.itemsByCourse[courseId]

                }
            }
        }


        initItemsByCourse();
    })

    watch(state, async () => {
        if (!stateTimer) {
            stateTimer = setTimeout(() => {
                writeToLocalStorage({
                    items: state.items,
                    address: state.address,
                    itemsByCourse: state.itemsByCourse,
                    tipPercentage: state.tipPercentage,
                    deliveryType: state.deliveryType,
                    pickupTimeMode: state.pickupTimeMode,
                    // pickupTime: state.pickupTime,
                    note: state.note,
                    // voucher: state.voucher,
                    phone: state.phone
                })

                stateTimer = null;
            }, 500)
        }
    }, { deep: true })





    return {
        ...toRefs(state),
        changeNote,
        getQuantityForProduct,
        totalNumberOfItems,
        productsInCart,
        itemsInCart,
        clear,
        emptyTheCart,
        getCartBreakdown,
        deleteItemFromCart,
        addProductToBasket,
        getCartItemById,
        countCartItemUp,
        countCartItemDown,
        applicableDiscounts,
        longestManufacturingTimeInMinutes
    }


}